import { render, staticRenderFns } from "./_CustomExtensions.vue?vue&type=template&id=5c3a621c&scoped=true&"
import script from "./_CustomExtensions.vue?vue&type=script&lang=ts&"
export * from "./_CustomExtensions.vue?vue&type=script&lang=ts&"
import style0 from "./_CustomExtensions.vue?vue&type=style&index=0&id=5c3a621c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a621c",
  null
  
)

export default component.exports